import React from "react";
import { Form } from "react-bootstrap";

import NumericEditor from "../atoms/NumericEditor";



function NumericControl(props) {
  const as_comp = props.as === undefined ? null : props.as === null ? null : props.as;

  return (
    <React.Fragment>
    {as_comp !== null &&
    <Form.Group className="mb-3" as={as_comp}>
      <Form.Label>{props.label}</Form.Label>
      <NumericEditor value={props.value} onChange={props.onChange} />
    </Form.Group>
    }

    {as_comp === null &&
    <Form.Group className="mb-3">
      <Form.Label>{props.label}</Form.Label>
      <NumericEditor value={props.value} onChange={props.onChange} />
    </Form.Group>
    }
      
  </React.Fragment>
  );
}


export default NumericControl;
